import { plnAmount, plnMonth } from '@iac/contracts';
import { useDict } from '../../i18n/dictionary';
import { useLocale } from '../../lib/locale';
import { usePageTitle } from '../../lib/page';
import { Badge } from '../../components/Badge';
import { DataTable, Td, Tr } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { Stat, StatGrid } from '../../components/Stat';
import { useOverview } from './api';
import { financesDict } from './i18n';

export function FinancesOverview() {
  const { locale } = useLocale();
  const t = useDict(financesDict);
  usePageTitle(t.overviewTitle);
  const { data: summary } = useOverview();

  if (!summary) return <PageHeader title={t.overview} />;

  return (
    <>
      <PageHeader title={t.overview} />
      <div id="overview-summary">
        <StatGrid>
          <Stat
            label={t.totalBalance}
            value={plnAmount(summary.totalBalance)}
          />
          <Stat
            label={t.totalTargets}
            value={plnAmount(summary.totalTargets)}
          />
          {summary.underfunded ? (
            <Stat
              label={t.shortfall}
              value={plnAmount(summary.shortfall)}
              tone="danger"
            />
          ) : (
            <Stat
              label={t.unallocated}
              value={plnAmount(summary.unallocated)}
            />
          )}
        </StatGrid>

        <DataTable
          columns={[
            { label: t.goal },
            { label: t.target, align: 'center' },
            { label: t.targetMonth, align: 'center', priority: 'secondary' },
            { label: t.allocated, align: 'center', priority: 'secondary' },
            { label: t.status, align: 'center' },
          ]}
          empty={t.noGoals}
        >
          {summary.goals.length > 0 &&
            summary.goals.map((goal) => (
              <Tr key={goal.id}>
                <Td emphasis>{goal.name}</Td>
                <Td numeric>{plnAmount(goal.targetAmount)}</Td>
                <Td>{plnMonth(goal.targetDate, locale)}</Td>
                <Td numeric>{plnAmount(goal.allocated)}</Td>
                <Td>
                  {goal.fullyFunded ? (
                    <Badge tone="success">{t.funded}</Badge>
                  ) : (
                    <>
                      <Badge tone="danger">
                        {t.short(plnAmount(goal.shortfall))}
                      </Badge>
                      <span className="cell-hint">
                        {t.monthsLeft(goal.monthsRemaining)}
                      </span>
                    </>
                  )}
                </Td>
              </Tr>
            ))}
        </DataTable>
      </div>
    </>
  );
}
